<template>
  <div
    class="flex flex-col md:flex-row md:items-stretch text-white leading-tight"
     v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }">
    <div class="w-full md:w-1/2 relative">
      <div class="absolute md:hidden left-0 z-10 p-4" style="top: 50%; transform: translateY(-50%);" @click="previousEvent()">
        <img src="/images/icon-caret-left-huge.svg" class="w-4">
      </div>
      <div class="absolute md:hidden right-0 z-10 p-4" style="top: 50%; transform: translateY(-50%);" @click="nextEvent()">
        <img src="/images/icon-caret-right-huge.svg" class="w-4">
      </div>
      <div id="event-image-holder">
        <transition name="fade" mode="out-in">
          <div :key="`event-image-${i}`" v-for="(event, i) in events" v-if="currentEventIndex == i">
            <img :src="event.image_full_url" :alt="event.name" class="mb-2">
            <p class="text-sm md:hidden">{{ event.year}}<br>{{ event.name }}</p>
          </div>
        </transition>
      </div>
    </div>
    <div class="w-full md:w-1/2 overflow-y-scroll hidden md:block" :style="{height: `${imageHeight}px`}">
      <div
        class="p-4 mb-2 cursor-pointer hover:bg-blue-300 hover:opacity-100 st-bgc"
        @click="selectEvent(i)"
        :class="currentEventIndex == i ? 'bg-blue-300' : 'bg-blue-400 opacity-25'"
        :key="`event-description-${i}`"
        v-for="(event, i) in events">
        {{ event.year }}<br>
        {{ event.name }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'home-history',
  props: {
    events: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      currentEvent: null,
      currentEventIndex: 0,
      imageHeight: 430,
      intersectionOptions: {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: [0, 1] // [0.25, 0.75] if you want a 25% offset!
      }
    }
  },
  methods: {
    /**
      * Calls the check-resolution method
      */
      callCheckRes() {
        this.updateImageHeight();
      },
      /**
       * Checks the window resolution in order to determine if it's a small one
       */
      updateImageHeight() {
        this.imageHeight = document.getElementById('event-image-holder').offsetHeight;
      },
      selectEvent(index) {
        this.currentEventIndex = index;
        this.currentEvent = this.events[this.currentEventIndex];
      },
      previousEvent() {
        if (this.currentEventIndex > 0) {
          this.currentEventIndex--;
        } else {
          this.currentEventIndex = this.events.length -1;
        }
        this.currentEvent = this.events[this.currentEventIndex];
      },
      nextEvent() {
        if (this.currentEventIndex < this.events.length -1) {
          this.currentEventIndex++;
        } else {
          this.currentEventIndex = 0;
        }
        
        this.currentEvent = this.events[this.currentEventIndex];
      },
      onWaypoint ({ going, direction }) {
        // going: in, out
        // direction: top, right, bottom, left
        if (going === this.$waypointMap.GOING_IN) {
          this.updateImageHeight();
        }
      }
  },
  mounted() {
    window.addEventListener('resize', this.callCheckRes);
  }
}
</script>